export default function GrokIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z"
        fill="white"
      />
      <rect
        x="2"
        y="2"
        width="12"
        height="12"
        fill="url(#pattern0_670_1424)"
      />
      <defs>
        <pattern
          id="pattern0_670_1424"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_670_1424"
            transform="translate(-0.0294118) scale(0.0294118)"
          />
        </pattern>
        <image
          id="image0_670_1424"
          width="36"
          height="34"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAYAAAA3WXuFAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAIgAAAAClThZcAAADpElEQVRYCc1X7VEiQRBdECwFrdrLYC8CMQIxA4xALgIhgoMMJILDCNQI9CIAI3AvAveH4Fcpvsdt7/UOM7PgXXlM1VT3dPf0vOnp6Z0NgjVpIdqaQAkCgqnVaudrAYhg6vX6CCT674AEzPb2dkfAlIT5COWuXl9fG29vb+FsNotKpVLMXqlU4iRJYp9Pgnl5ebmCTTKZTA7FdmVAdPT8/HwCB230CN3aAGwMxaBarV6b4La2tqJyuUww0ebm5letXwkQQnuChXpwtMqNiBG9wcPDwynmBRoMfA0RnW+US6sI46NpeM/huOmzc+hCLEwX4ePjYyiRoS2i1zfnFALijnBE8/Cak7HQNWQ36DweaQ0wB+gJ+hkiMAQNkGfZMXGMNtZH9VsUBIWANjY2GJlIJpASCHr//v7+WstdvD4mZfNL8RnrBYRi9R1guGPd+th1Twt8vAMMN3Vnm1e2CSmjI5AOedX60+m0p8Ze1gXGN8kJCMnXxsRQJvOY/iUYRP6L+NbUCQhGx9oQNyJ3PbXO5M3IYDMD9K5ht2eM3UM6RP7MpONbw1u2VEvn3qZzb3d2dpoyEbI78UnKUiA6odYIIRq5REZ4f8oEH9WR4RGjCh8aN/FSz0c5aeoxeest47fJMBwb44WhBoMNdJFvpwtGQRBrGUCb67gBwTibiwRPsoGFUWB4nfcBpnADFjdzkfXITADYceRyIGAA5BJHtI8atTQY+F3YqPXIsLjptGEDRDCs5NCxWA5tNloG0AcAkYkwjrOBj2H2GzdioaoSDGyGMI18vkSX2mc3l/5Fp6n1yPDRS4BeRynUr7o0Mk3kStv2gdQLCI80yNU1+L8QnaZ/MldLwe/u7rbwGuRxSEuYI3hC8LNCzIkoiig3AEC32g5jsyTM1dYIUYPnpY4QRXxy/vggmFxhRXSGRn2i/3lzAhIDRWN+PlaJDKOMSIzgIzL89NU4x7puGV9zDRzZ3Jj5hPERwMQUMOmfnp7aWCyBPPdmpg6RbMHsGPObtNcNt7IrfrRceGcO8fuFK9qE4Rlyp8PIcLH0gd+BPBQnoEnaKdNyZRLwonSLyoMVUPqYP4W37P1DMPxtAciGXmVJPgaYo1WKZuYXkWmkNaiXCRUDfRt6+ZrrumLj+XXvcTPKhZfNRSitL7zqg6LQ8lmBaLVguwcaySqIRAz+BvTCdZPE1ksJBrsfMUJew89QpmCuENnoM9YrXAPnfL42YIh2laQr3N1fGrwDBtZye9LPCr0AAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
}
